// Zámek plochy a znovupřihlášení nad plochou: okna zůstávají, po ověření práce pokračuje.
import { api, ApiError, setToken } from '../api';
import { h } from '../dom';
import { t, tk } from '../i18n';
import { icon } from '../icons';
import type { UserInfo } from '../contract';

export type LockMode = 'locked' | 'relogin';

export function lockScreen(user: UserInfo, mode: LockMode, onSwitchUser: () => void): Promise<void> {
  return new Promise((resolve) => {
    document.querySelector('.lock-screen')?.remove();
    const pwd = h('input', { class: 'input', type: 'password', autocomplete: 'current-password', placeholder: t('core.ui.password'), 'aria-label': t('core.ui.password') });
    const flash = h('div', { class: 'flash', hidden: true });
    const btn = h('button', { type: 'submit', class: 'btn primary wide' }, mode === 'locked' ? t('core.ui.unlock') : t('core.ui.sign_in'));
    const form = h(
      'form',
      { class: 'lock-box' },
      h('div', { class: 'lock-avatar' }, user.name.split(' ').map((p) => p[0] ?? '').join('').slice(0, 2).toUpperCase()),
      h('div', { class: 'lock-name' }, user.name),
      h('div', { class: 'lock-hint muted' }, mode === 'locked' ? t('core.ui.lock_hint') : t('core.ui.session_lost')),
      flash,
      pwd,
      btn,
      h('button', { type: 'button', class: 'btn ghost wide', onClick: () => {
        overlay.remove();
        onSwitchUser();
      } }, icon('switch-user'), t('desktop.shell.switch_user')),
    );
    const overlay = h('div', { class: 'lock-screen ' + mode, role: 'dialog', 'aria-modal': 'true' }, h('div', { class: 'lock-clock' }), form);
    const clock = overlay.querySelector('.lock-clock') as HTMLElement;
    const tick = () => {
      clock.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };
    tick();
    const timer = window.setInterval(tick, 10000);
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.disabled = true;
      flash.hidden = true;
      try {
        if (mode === 'locked') {
          await api('/auth/unlock', { password: pwd.value });
        } else {
          const res = await api<{ token: string; user: UserInfo }>('/auth/login', { login: user.login, password: pwd.value, remember: false });
          setToken(res.token);
        }
        window.clearInterval(timer);
        overlay.remove();
        resolve();
      } catch (err) {
        const ae = err as ApiError;
        if (ae.status === 401 && mode === 'locked' && ae.code !== 'login_failed') {
          // relace mezitím vypršela → plné přihlášení
          window.clearInterval(timer);
          overlay.remove();
          resolve(lockScreen(user, 'relogin', onSwitchUser));
          return;
        }
        flash.textContent = tk(ae.message ?? 'core.login.failed');
        flash.hidden = false;
        pwd.value = '';
        pwd.focus();
      } finally {
        btn.disabled = false;
      }
    });
    document.body.appendChild(overlay);
    pwd.focus();
  });
}
